import instance from "../../../shared/components/auth/service/AxiosInstance";

const AddressService = {

    searchStreet: (query, limit) => instance.get(process.env.REACT_APP_API_URL + "streets/street/search", {
        params: { query, limit },
    }),

    searchMunicipality: (query, limit) => instance.get(process.env.REACT_APP_API_URL + "streets/municipality/search", {
        params: { query, limit },
    }),

    getMunicipalities: () => instance.get(process.env.REACT_APP_API_URL + "streets/municipality/all"),
}

export { AddressService };
export default AddressService;